import React from 'react';
import "./index.css";

function Button({title}) {
  return (
    <button>{title}</button>
  )
}

export default Button;